<template>
  <div class="right_col" role="main" style="min-height: 756px">
    <div class="">
      <div class="page-title">
        <div class="title_left">
          <h3>{{ $t('orderPage.lineup') }}</h3>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="x_panel item_list">
        <div class="x_content">
          <alert
            :title="alertTitle"
            :success-message="$t('common.isSuccess')"
            :error-message="$t('common.isFailure')"
            :alerts="alerts"
            :errors="errors"
            :display="alertDisplay"
            @closeAlert="closeAlert"
          />
          <div class="text-right">
            <router-link to="/order/item/create" class="btn btn-primary">{{
              $t('common.create')
            }}</router-link>
            <div class="dropdown">
              <button
                @click="toggleUpload"
                @click.stop
                class="btn btn-primary dropdown-toggle"
                type="button"
              >
                {{ $t('common.csvUpload') }}
                <span class="caret"></span>
              </button>
              <ul :class="{ visible: isUploadVisible }" class="dropdown-menu">
                <li>
                  <router-link to="/order/item/csv">{{
                    $t('orderPage.itemCsvUpload')
                  }}</router-link>
                </li>
                <li>
                  <router-link to="/order/item/calorie/csv">{{
                    $t('orderPage.calorieCsvUpload')
                  }}</router-link>
                </li>
              </ul>
            </div>
            <div class="dropdown">
              <button
                @click="toggleDownload"
                @click.stop
                class="btn btn-default dropdown-toggle"
                type="button"
              >
                {{ $t('common.csvDownload') }}
                <span class="caret"></span>
              </button>
              <ul :class="{ visible: isDownloadVisible }" class="dropdown-menu">
                <li>
                  <a
                    :href="csvURL"
                    :download="csvFileName"
                    @click="csvDownLoad"
                    >{{ $t('orderPage.itemCsvDownload') }}</a
                  >
                </li>
                <li>
                  <a
                    :href="calorieCsvURL"
                    :download="calorieCsvFileName"
                    @click="calorieCsvDownLoad"
                    >{{ $t('orderPage.calorieCsvDownload') }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div
            id="datatable_wrapper"
            class="dataTables_wrapper form-inline dt-bootstrap no-footer"
          >
            <div class="row">
              <div class="col-sm-6">
                <table-length @changeRowPerPage="changeRowPerPageCount" />
              </div>
              <div class="col-sm-6">
                <div id="datatable_filter" class="dataTables_filter">
                  <label
                    >{{ $t('common.search') }}:
                    <input
                      v-model="searchString"
                      @keyup="searchWord"
                      type="search"
                      class="form-control input-sm"
                      placeholder=""
                      aria-controls="datatable"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <app-table
                  :display-items="displayItems"
                  :column-titles="tableHeaderColumns"
                  @buttonClickEvent="buttonClickEvent"
                  @sortTable="sortTable"
                />
              </div>
            </div>
            <pagination
              :page-par-item-count="displayItemPerPageCount"
              :total-item-count="totalItemCount"
              :current-page="currentPage"
              @changePage="changePage"
            />
          </div>
        </div>
      </div>
      <div
        :class="{ 'is-open': isModalActive }"
        @click="toggleModal()"
        class="p-modal"
      >
        <img :src="modalImage" />
      </div>
    </div>
  </div>
</template>
<script>
import Alert from '@/components/common/alert/Alert'
import Pagination from '@/components/tabale/Pagination'
import TableLength from '@/components/tabale/TableLength'
import Table from '@/components/common/table/Table'
import { mapGetters } from 'vuex'
import list from '@/mixin/list'
import alert from '@/mixin/alert'
import ItemRequest from '@/http/ItemRequest'
import Papa from 'papaparse'

export default {
  components: {
    Alert,
    Pagination,
    TableLength,
    AppTable: Table,
  },
  mixins: [list, alert],
  data() {
    return {
      tableHeaderColumns: [
        this.$t('common.itemCode'),
        this.$t('common.itemName'),
        this.$t('common.calorie'),
        this.$t('common.manufacturingCategory'),
        this.$t('common.topping'),
        this.$t('orderPage.priceChange'),
        this.$t('common.normalImage'),
        this.$t('common.wideImage'),
        this.$t('common.edit'),
      ],
      isModalActive: false,
      modalImage: '',
      csvURL: '',
      csvFileName: '',
      calorieCsvURL: '',
      calorieCsvFileName: '',
      isUploadVisible: false,
      isDownloadVisible: false,
    }
  },
  computed: {
    ...mapGetters({
      getItemById: 'item/getItemById',
      fetchedData: 'item/getItems',
      language: 'settings/getLanguage',
    }),
  },
  watch: {
    fetchedData: function(newFetchedData) {
      const data = newFetchedData
      this.fetchItems = data.list.map((item) => {
        const isPriceChange = item.isPriceChange
          ? this.$t('orderPage.applicable')
          : this.$t('orderPage.notApplicable')
        return [
          item.itemCode,
          item.names[this.language],
          this.formatCalorie(item.calorie),
          item.itemKind.name,
          Object.values(item.toppings).join(','),
          isPriceChange,
          this.makeNormalImageButton(item),
          this.makeWideImageButton(item),
          { type: 'edit', id: item.itemCode },
        ]
      })
      this.allItems = this.fetchItems
    },
    language() {
      this.$store.dispatch('item/getItems')
      this.fetchItems = this.fetchedData.list.map((item) => {
        const isPriceChange = item.isPriceChange
          ? this.$t('orderPage.applicable')
          : this.$t('orderPage.notApplicable')
        return [
          item.itemCode,
          item.names[this.language],
          this.formatCalorie(item.calorie),
          item.itemKind.name,
          Object.values(item.toppings).join(','),
          isPriceChange,
          this.makeNormalImageButton(item),
          this.makeWideImageButton(item),
          { type: 'edit', id: item.itemCode },
        ]
      })
      this.allItems = this.fetchItems
    },
  },
  mounted() {
    let params = {}
    if (this.$route.params.succeeded === true) {
      this.alertTitle = this.$route.params.title
      this.openSuccessAlert()
      params = { master: 1 }
    }

    this.$store.dispatch('item/getItems', params)
  },
  beforeMount() {
    document.addEventListener('click', this.hideDropdown)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.hideDropdown)
  },
  methods: {
    buttonClickEvent: function(type, id) {
      switch (type) {
        case 'edit':
          this.edit(id)
          break
        case 'normalImageDisplay':
          this.displayNormalImage(id)
          break
        case 'normalImageDestroy':
          this.destroyImage('normal', id)
          break
        case 'wideImageDisplay':
          this.displayWideImage(id)
          break
        case 'wideImageDestroy':
          this.destroyImage('wide', id)
          break
      }
    },
    edit: function(id) {
      this.$router.push({ name: 'itemformEdit', params: { id: id } })
    },
    csvDownLoad: function() {
      const headerColumns = [
        this.$t('orderPage.updateCategory'),
        this.$t('orderPage.itemCode'),
        this.$t('orderPage.productionLanguage1'),
        this.$t('orderPage.provideUnitId'),
        this.$t('orderPage.typesOfGarnishments'),
        this.$t('orderPage.manufacturingDivisionId'),
        this.$t('orderPage.tagTextString'),
        this.$t('orderPage.priceChange'),
        this.$t('orderPage.productionLanguage2'),
        this.$t('orderPage.productionLanguage3'),
        this.$t('orderPage.productionLanguage4'),
        this.$t('orderPage.productionLanguage5'),
      ]
      const allItems = this.fetchedData.list.map((item) => [
        this.$t('operationalManagementPage.update'),
        item.itemCode,
        item.names['ja'],
        item.unit,
        Object.keys(item.toppings).join('_'),
        item.itemKind.id,
        item.searchTags.map((tag) => tag.name).join('_'),
        item.isPriceChange,
        item.names['us'],
        item.names['zh-tw'],
        item.names['kr'],
        item.names['zh-cn'],
      ])
      const content = [headerColumns].concat(allItems)
      const config = {
        delimiter: ',',
        header: true,
        newline: '\r\n',
      }
      // 区切り文字へ変換
      const delimiterString = Papa.unparse(content, config)
      // blobへの変換
      const blob = new Blob([delimiterString], { type: 'text/csv' })
      this.csvFileName = 'itemlist'
      this.csvURL = (window.URL || window.webkitURL).createObjectURL(blob)
    },
    calorieCsvDownLoad: function() {
      const allItems = this.fetchedData.list.map((item) => [
        item.itemCode,
        '',
        '',
        item.calorie == null
          ? ''
          : item.calorie + this.$t('common.calorieUnit'),
      ])
      const config = {
        delimiter: ',',
        newline: '\r\n',
      }
      // 区切り文字へ変換
      const delimiterString = Papa.unparse(allItems, config)
      // blobへの変換
      const blob = new Blob([delimiterString], { type: 'text/csv' })
      this.calorieCsvFileName = 'calorielist'
      this.calorieCsvURL = (window.URL || window.webkitURL).createObjectURL(
        blob
      )
    },
    // 通常画像をモーダル表示する
    displayNormalImage: function(id) {
      this.changeModalImage('normal', id)
      this.toggleModal()
    },
    // ワイド画像をモーダル表示する
    displayWideImage: function(id) {
      this.changeModalImage('wide', id)
      this.toggleModal()
    },
    // 画像の削除
    destroyImage: function(type, id) {
      let types = 0
      let imageTypeName = ''
      if (type === 'normal') {
        types = 1
        imageTypeName = this.$t('common.normal')
      } else if (type === 'wide') {
        types = 2
        imageTypeName = this.$t('common.wide')
      }

      if (
        !window.confirm(
          `${this.$t(
            'orderPage.imageDeletionConfirmationBefore'
          )}${imageTypeName}${this.$t(
            'orderPage.imageDeletionConfirmationAfter'
          )}`
        )
      ) {
        return false
      }

      const request = new ItemRequest()
      const paramas = {
        itemCode: id,
        types: [types], // 1...通常表示, 2...幅広表示
      }
      request
        .deleteImage(paramas)
        .then(() => {
          this.openSuccessAlert()
        })
        .catch((err) => {
          this.openErrorAlert(err.response.data)
        })
        .finally(() => {
          this.alertTitle = `${imageTypeName}${this.$t(
            'orderPage.deleteItemImage'
          )}`
          const params = { master: 1 }
          this.$store.dispatch('item/getItems', params)
        })
    },
    // モーダル表示非表示の切り替え
    toggleModal() {
      this.isModalActive = !this.isModalActive
    },
    // モーダルで表示する画像の差し替え
    changeModalImage: function(type, id) {
      const item = this.getItemById(id)
      if (type === 'wide') {
        this.modalImage = item.largeImage
      } else if (type === 'normal') {
        this.modalImage = item.normalImage
      } else {
        this.modalImage = ''
      }
    },
    // 一覧表のワイド画像のボタンをつくる処理
    makeWideImageButton: function(item) {
      if (!item.largeImage) {
        return ''
      }
      return [
        { type: 'wideImageDisplay', id: item.itemCode },
        { type: 'wideImageDestroy', id: item.itemCode },
      ]
    },
    // 一覧表の通常画像のボタンをつくる処理
    makeNormalImageButton: function(item) {
      if (!item.normalImage) {
        return ''
      }
      return [
        { type: 'normalImageDisplay', id: item.itemCode },
        { type: 'normalImageDestroy', id: item.itemCode },
      ]
    },
    sortTable: function(newArray) {
      this.displayItems = newArray
    },
    formatCalorie(calorie) {
      return calorie == null
        ? ''
        : calorie.toLocaleString() + this.$t('common.calorieUnit')
    },
    hideDropdown() {
      this.isDownloadVisible = false
      this.isUploadVisible = false
    },
    toggleUpload() {
      this.isDownloadVisible = false
      this.isUploadVisible = !this.isUploadVisible
    },
    toggleDownload() {
      this.isUploadVisible = false
      this.isDownloadVisible = !this.isDownloadVisible
    },
  },
}
</script>
<style scoped>
.dropdown {
  display: inline-block;
}
.visible {
  display: block;
}
</style>
